import SearchSubscriptionPlanOverview from './SearchSubscriptionPlanOverview';

export default SearchSubscriptionPlanOverview;
